import React from 'react';
import PropTypes from 'prop-types';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import Button from '@mui/material/Button';
import intl from 'react-intl-universal';
import NotificationsRedux from './NotificationsRedux';

const iconVariant = {
  success: <span className="circle-check-icon" />,
  error: <span className="circle-error-icon" />,
};

const renderDismissAction = snackbarId => (
  <Button key="dismiss" size="small" className="dismiss-button" onClick={() => closeSnackbar(snackbarId)}>
    {intl.get('messaging.notifications.dismiss')}
  </Button>
);

class NotificationProvider extends React.Component {
  state = {
    notifications: [],
  };

  storeDisplayed = key => {
    this.setState(({ displayed }) => ({
      displayed: [...displayed, key],
    }));
  };

  render() {
    return (
      <SnackbarProvider
        maxSnack={5}
        autoHideDuration={5000}
        className="notifications"
        iconVariant={iconVariant}
        classes={{
          message: 'notifications-message',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        action={renderDismissAction}>
        <React.Fragment>
          {this.props.children}
          <NotificationsRedux />
        </React.Fragment>
      </SnackbarProvider>
    );
  }
}

NotificationProvider.propTypes = {
  children: PropTypes.node,
};

export default NotificationProvider;
